import React, { useState } from 'react'

import { Button, Popover } from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'

import { theme } from 'styles/theme'

import { CHARGE_VARIANTS, DescriptionVariant } from './variants'

type PopoverNewVariantProps = {
  description?: string
  setDescription: (description: string) => void
  noChars?: boolean
  onAddItemsVariable?: () => void
  hasItemsVariable?: boolean
  variants?: DescriptionVariant[]
  /** Insere a variável no cursor do campo (ver `useInsertAtCursor`). */
  insertAtCursor?: (current: string, text: string) => string
}

const PopoverNewVariant = ({
  setDescription,
  description = '',
  noChars,
  onAddItemsVariable,
  hasItemsVariable = false,
  variants = CHARGE_VARIANTS,
  insertAtCursor = (current, text) => current + text
}: PopoverNewVariantProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickVariant = (variant: string) => {
    // Não permitir adicionar {{itens_da_cobranca}} se já existe
    if (variant === '{{itens_da_cobranca}}' && hasItemsVariable) {
      handleClose()
      return
    }

    setDescription(insertAtCursor(description, variant))

    // Se a variável adicionada for {{itens_da_cobranca}} e o callback existir, chama o callback
    if (variant === '{{itens_da_cobranca}}' && onAddItemsVariable) {
      onAddItemsVariable()
    }

    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'popover-note' : undefined

  return (
    <Box mt={0.5} {...(noChars ? {} : { width: '100%' })}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={noChars ? 'flex-end' : 'space-between'}
      >
        {!noChars && (
          <Typography variant="xsLight" color={theme.palette.neutral[400]}>
            Caracteres: {description?.length}/2000
          </Typography>
        )}

        <Box display="flex" alignItems="center" gap={1}>
          <Button startIcon="add" variantButton="ghost" onClick={handleClick}>
            Adicionar variável
          </Button>
        </Box>
      </Box>

      <Popover
        // Não devolve o foco pro botão: o `insertAtCursor` devolve pro campo.
        disableRestoreFocus
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        id={id}
        open={open}
        onClose={handleClose}
      >
        <Box width="300px" display="flex" flexDirection="column">
          {variants.map((variant) => {
            const isItemsVariable = variant.value === '{{itens_da_cobranca}}'
            const isDisabled = isItemsVariable && hasItemsVariable

            return (
              <Button
                key={variant.name}
                onClick={() => handleClickVariant(variant.value)}
                variantButton="ghost"
                fullWidth
                disabled={isDisabled}
                style={{
                  opacity: isDisabled ? 0.5 : 1,
                  cursor: isDisabled ? 'not-allowed' : 'pointer'
                }}
              >
                {variant.name}
                {isDisabled && ' (já adicionado)'}
              </Button>
            )
          })}
        </Box>
      </Popover>
    </Box>
  )
}

export default PopoverNewVariant
